import type { Aggregates } from 'hooks/useSpaceSearch';
import { useContext } from 'react';

import { dateFormatForMobileUI } from 'utils/date';
import { SearchContext } from '../../state/search';
import DatepickerField from '../fields/datepickerField';
import NestedFilterDropdown from '../nestedFilterDropdown';
import Switch from '../switch';

interface Props {
  currentViewType?: string;
  updateCurrentPage: (pageNumber: number) => void;
  changeViewType: (toggled: boolean) => void;
  aggregates?: Aggregates;
}

const defaultAggregates: Aggregates = { property: [], distance: [] };

const MobileSpaceFilters = ({
  currentViewType = 'list',
  updateCurrentPage,
  changeViewType,
  aggregates = defaultAggregates,
}: Props) => {
  const { filters, actions } = useContext(SearchContext);

  return (
    <div className="mobile-space-filters">
      <div className="mobile-space-filters__container">
        <DatepickerField
          value={filters.date}
          onChange={date => {
            updateCurrentPage(1);
            actions.updateDate(date);
          }}
          dateFormat={dateFormatForMobileUI}
        />
        <NestedFilterDropdown
          aggregates={aggregates}
          filters={filters}
          actions={actions}
          updateCurrentPage={updateCurrentPage}
        />
        <div className="mobile-space-filters__switch">
          <Switch
            offLabel="Map"
            onLabel="List"
            toggled={currentViewType === 'map'}
            onSwitchChange={changeViewType}
          />
        </div>
      </div>
    </div>
  );
};

export default MobileSpaceFilters;
